<template>
  <div id="scroll-div-recommend" class="main layer2" style="height: calc(100% - 5rem); padding-bottom: 2.5rem; padding-top: 2.3rem; overflow: auto;">
    <top id="top-nav" title="新书速递"></top>
    <books-small :show-title="false" :books="books.small"></books-small>
    <books-large :show-title="false" :books="books.large"></books-large>
    <loading ref="loading" scroll-div="scroll-div-recommend" :is-loading="isLoading" :is-no-more-data="isNoMoreData" @get-books="getBooks(currentPage + 1)"></loading>
    <bottom></bottom>
  </div>
</template>

<script>
  import BooksSmall from '@/components/novel/books-small'
  import BooksLarge from '@/components/novel/books-large'
  import Loading from "../../../components/share/loading"
  import novelService from "../../../services/novelService";
  import Bottom from '@/components/layer1/bottomIndex'
  import BookTop from '@/components/layer2/book/book-top'
  export default {
    name: 'novel-xbtj',
    data() {
      return {
        componentName: '',
        books: {
          small: [],
          large: []
        },
        isLoading: false,
        isNoMoreData: false,
        currentPage: 1
      }
    },
    methods: {
      getBooks(target) {
        this.currentPage = target;
        if(target === 1) {
          this.books = {small: [], large: []}
        }
        this.isLoading = true;
        this.isNoMoreData = false;
        novelService.getMoreList(target,'new_on')
          .then(res => {
            this.isLoading = false;
            if (res.data.totalPage === 0) {
              this.isNoMoreData = true;
              this.books = {small: [], large: []}
            } else if (this.currentPage === 1) {
              let data = res.data.novelBookList;
              this.books.small = data.splice(0, 3);
              this.books.large = data;
            } else if (this.currentPage > 1 && this.currentPage <= res.data.totalPage) {
              this.books.large.push(...res.data.novelBookList);
            }
            if (res.data.totalPage == 0 || this.currentPage >= res.data.totalPage) {
              this.isNoMoreData = true;
            }
            setTimeout(() => {
              this.$refs['loading'].scrollFunction();
            }, 0)
          })
      }
    },
    components: {
      'books-small': BooksSmall,
      'books-large': BooksLarge,
      loading: Loading,
      bottom: Bottom,
      top: BookTop
    },
    mounted() {
      this.componentName = this.$route.name;
      console.log(this.componentName, this.$store.state.pageState[this.componentName]);
      if(this.$store.state.pageState[this.componentName] && this.$router.isBack) {
        Object.assign(this.$data, this.$store.state.pageState[this.$route.name].data);
        setTimeout(() => {
          let scrollDiv = document.getElementById('scroll-div-recommend');
          scrollDiv.scrollTop = this.$store.state.pageState[this.$route.name].top;
        }, 5);
      }
      else {
        this.getBooks(1);
      }
      this.$router.isBack = true;
    },
    beforeDestroy() {
      let scrollDiv = document.getElementById('scroll-div-recommend');
      let state = {};
      state[this.componentName] = {data: this.$data, top: scrollDiv.scrollTop}
      this.$store.commit('saveState', state);
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/layer2/novels/xssd.vue